import axiosInstance from '../lib/axios';

// Function to fetch users
export const fetchUsers = async ({ queryKey }) => {
    const [_key, { currentPage, search, lastLogin, userType, enrollmentDate, organization, plan, planType, statusType }] = queryKey;
    const response = await axiosInstance.get('/admin/users', {
        params: { page: currentPage, limit: 12, search, lastLogin, userType, enrollmentDate, organization, plan, planType, statusType }
    });
    return response.data;
};

// Function to delete user
export const deleteUser = (id) => axiosInstance.delete(`/admin/users/${id}`);

export const fetchUsersByIds = async (ids) => {
    const response = await axiosInstance.post('/admin/users/by-ids', { ids });
    return response.data;
};

